import PropTypes from 'prop-types';
import { useState } from 'react';

import { Dialog, Button } from '@ctct/ui-react';

const UpgradeModal = ({ t, onClose, onOpenUpgradeDialog }) => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <Dialog
      heading={t('add_user.heading')}
      isOpen={isOpen}
      data-qe-id="upgrade-modal"
      footerActions={
        <>
          <Button data-qe-id="upgrade-modal-no-thanks" onClick={onClose} text={t('upgrade.nothanks')} />
          <Button
            onClick={() => {
              setIsOpen(false);
              onOpenUpgradeDialog();
            }}
            text={t('upgrade.buynow')}
            kind="primary"
          />
        </>
      }
    >
      <h3>{t('upgrade.heading')}</h3>
      <p>{t('upgrade.text')}</p>
    </Dialog>
  );
};

UpgradeModal.propTypes = {
  t: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};
export default UpgradeModal;

export { UpgradeModal };
